import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { SummaryPanel } from './def/summary-content';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { BaseContentService } from './base-content-service';

@Injectable()
export class SummaryContentService extends BaseContentService<SummaryPanel> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, SummaryContentService.staticSummary);
  }

  get data$(): Observable<SummaryPanel> {
    if (!this.loaded) {
      return this.getSummaryData();
    }

    return of(this.data);
  }

  public set loadFromCache(flag: boolean) {
    this.loaded = flag;
  }

  getSummaryData(): Observable<SummaryPanel> {
    const url = `${this.serviceBaseUrl}summarypanel`;
    return this.get<SummaryPanel>(url).pipe(
      map(data => {
        this.data = this.summaryMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private summaryMapper(data: SummaryPanel): SummaryPanel {
    if (!data) return;

    return data;
  }

  private static staticSummary: SummaryPanel = {
    pageName: 'summarypanel',
    summaryPanel: [
      {
        name: '',
        menu: [
          {
            name: '',
            iconClass: '',
            active: true,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          },
          {
            name: '',
            iconClass: '',
            active: false,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          },
          {
            name: '',
            iconClass: '',
            active: false,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          },
          {
            name: '',
            iconClass: '',
            active: false,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          },
          {
            name: '',
            iconClass: '',
            active: false,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          }
        ]
      },
      {
        name: '',
        menu: [
          {
            name: '',
            iconClass: '',
            active: true,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          },
          {
            name: '',
            iconClass: '',
            active: false,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          },
          {
            name: '',
            iconClass: '',
            active: false,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          },
          {
            name: '',
            iconClass: '',
            active: false,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          },
          {
            name: '',
            iconClass: '',
            active: false,
            submenu: [
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              },
              {
                name: '',
                url: '',
                heading: '',
                image: null,
                displayItems: []
              }
            ]
          }
        ]
      }
    ]
  };
}
